import { createReducer, on } from "@ngrx/store";
import { DadosContatosOutputDto } from "src/app/domain/DTOs/output/dados-contatos-output-dto";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterDadosContatos, obterDadosContatosSuccess } from "../actions/obter-dados-contatos.action";

export interface ObterDadosContatosState {
    response: EstruturaRetornoDadosOutputDto<DadosContatosOutputDto> | null;
    error: string[] | null;
}

export const initialState: ObterDadosContatosState = {
    response: null,
    error: null,
};

export const ObterDadosContatosReducer = createReducer(
    initialState,
    on(obterDadosContatos, state => ({ ...state, error: null })),
    on(obterDadosContatosSuccess, (state, { response }) => ({ ...state, response, error: null })),
);
